import React from "react";
import { useTheme } from "../context/ThemeContext";

const fieldLabels = {
    Name: "Nume",
    Phone: "Telefon",
    City: "Oraș",
    Street: "Stradă",

    TotalPrice: "Preț total",
    PreferentialPrice: "Preț preferențial",
    DiscountPercentage: "Discount (%)",
    TotalCost: "Cost total",
    GrossProfit: "Profit brut",
    ProfitMargin: "Marjă profit (%)",

    Finalizat: "Finalizat",
    IsAdvanceOrder: "Comandă cu avans",

    CreatedAt: "Creat la",
    UpdatedAt: "Modificat la",

    OrderNumber: "Număr comandă",
    UserName: "Utilizator",
    CustomerName: "Client",
    Amount: "Sumă",
    PaymentDate: "Data de plată",
    Note: "Descriere",
    CreatedByUserName: "Creat de",

    DrawingUrl: "Fișier schiță (URL)",
    DrawingFileName: "Nume fișier schiță",
    InvoiceUrl: "Fișier factură (URL)",
    InvoiceFileName: "Nume fișier factură",
    County: "Județ",
    BusinessType: "Tip Afacere",
    Notes: "Descriere",
    AgentName: "Nume Agent",
    RefusalReason: "Motiv refuz",
    Type: "Tip Client",

    CategoryName: "Nume categorie",
    Price: "Preț",
    PriceMarmurist: "Preț marmurist",
    AvailableStock: "Stoc disponibil",
    UnitType: "Unitate",
    CostPrice: "Preț cost",
    ImageUrl: "Imagine (URL)",
    Nr: "Număr ofertă",
    TipClient: "Tip client",
    Notita: "Notiță",
    PretMontaj: "Preț montaj",
    CantitateMontaj: "Cantitate montaj",
    PretLivrare: "Preț livrare",
    LivrareRuta: "Rută livrare",
    // ItemsTotal: "Total articole",
    // DiscountAmount: "Suma discount",
    // NetAfterDiscount: "Net după discount",
    // Tva: "TVA",
    // Subtotal: "Subtotal",
    // Status: "Status",
    UseMarmuristPricing: "Preț marmurist",
    ApprovedAt: "Data aprobării",
    Description: "Descriere",

    AffectedUserName: "Utilizator",

    MonthYear: "An / Lună",

};

const formatValue = (v) => {
    if (v === true) return "Da";
    if (v === false) return "Nu";
    if (v === null || v === undefined || v === "") return "—";

    if (typeof v === "string" && v.startsWith("http")) {
        return `<a href="${v}" target="_blank" rel="noopener noreferrer" class="text-blue-500 underline">${v}</a>`;
    }

    // DATE detection
    if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T/.test(v)) {
        const d = new Date(v);
        return d.toLocaleString("ro-RO", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    }

    return v;
};

const AuditDiffTable = ({ oldObj, newObj, isCreate }) => {
    const { darkMode } = useTheme();
    if (!oldObj && !newObj) return null;

    const exclude = [
        "Id", "OrderId", "UserId", "CustomerId",
        "TotalPrice", "DrawingUrl", "DrawingFileName",
        "InvoiceUrl", "InvoiceFileName", "AgentId",
        "CategoryId", "CategoryName", "DisplayName", "ItemsTotal", "DiscountAmount", "NetAfterDiscount", "Tva", "Total", "Subtotal", "AffectedUserId", "ApprovedAt"
    ];

    const keys = Object.keys({ ...oldObj, ...newObj }).filter(
        (k) => !exclude.includes(k)
    );

    return (
        <table
            className={`w-full text-sm border mt-3 ${darkMode ? "border-gray-700" : "border-gray-300"
                }`}
        >
            <thead>
                <tr
                    className={`${darkMode ? "bg-gray-700 text-white" : "bg-gray-200"
                        }`}
                >
                    <th className="p-2 text-left">Câmp</th>

                    {/* ❗ ONLY show VECHI if NOT CREATE */}
                    {!isCreate && (
                        <th className="p-2 text-left">Vechi</th>
                    )}

                    <th className="p-2 text-left">Nou</th>
                </tr>
            </thead>

            <tbody>
                {keys.map((k) => {
                    const a = oldObj?.[k];
                    const b = newObj?.[k];

                    // CREATE → only show new value
                    if (isCreate) {
                        return (
                            <tr
                                key={k}
                                className={`${darkMode ? "border-gray-700" : "border-gray-300"
                                    } border-t`}
                            >
                                <td className="p-2 font-semibold w-[40%]">
                                    {fieldLabels[k] || k}
                                </td>
                                <td className="p-2 text-green-600"
                                    dangerouslySetInnerHTML={{ __html: formatValue(b) }}>
                                </td>
                            </tr>
                        );
                    }

                    // UPDATE → skip identical
                    if (a === b) return null;

                    return (
                        <tr
                            key={k}
                            className={`${darkMode ? "border-gray-700" : "border-gray-300"
                                } border-t`}
                        >
                            <td className="p-2 font-semibold w-[40%] min-w-[180px]">
                                {fieldLabels[k] || k}
                            </td>

                            <td className="p-2 text-red-500 w-[35%] break-all"
                                dangerouslySetInnerHTML={{ __html: formatValue(a) }}>
                            </td>

                            <td className="p-2 text-green-600 w-[25%] break-all"
                                dangerouslySetInnerHTML={{ __html: formatValue(b) }}>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default AuditDiffTable;
